import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';
import {
  entityIntegranteAddFailure,
  entityIntegranteAddRequest,
  entityIntegranteAddSuccess,
  entityIntegranteChangeFailure,
  entityIntegranteChangeRequest,
  entityIntegranteChangeSuccess,
  entityIntegranteDeleteRequest,
  entityIntegranteDeleteSuccess
} from './entity-integrante.actions';

import { Update } from '@ngrx/entity';

import { entityRolChangeSuccess } from '../entity-roles/entity-roles.actions';
import { IntegranteService } from '../integrante/integrante.service';
import { Integrante } from '../integrante/integrante.model';
import { Rol } from '../entity-roles/roles.model';
import { NotificationService } from '../../../core/core.module';

@Injectable()
export class IntegranteEffects {
  [x: string]: any;
  //load
  // loadRequestIntegrante = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(entityIntegranteLoadRequest),
  //     mergeMap(() =>
  //       this.integranteService.getIntegrante().pipe(
  //         map((items) => entityIntegranteLoadSuccess({ items })),
  //         catchError((error) => of(entityIntegranteLoadFailure({ error })))
  //       )
  //     )
  //   )
  // );

  // add
  addRequestIntegrante = createEffect(() =>
    this.actions$.pipe(
      ofType(entityIntegranteAddRequest),
      switchMap((action) =>
        this.integranteService.addIntegrante(action.item).pipe(
          map((item) => entityIntegranteAddSuccess({ item })),
          catchError((error) => of(entityIntegranteAddFailure({ error })))
        )
      )
    )
  );

  addSuccessIntegrante = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityIntegranteAddSuccess),
        tap((item) => {
          if (item.item.rol.tipo_rol_id === 6) {
            this.notificationService.success('Notificación enviada a Técnico/a Responsable para aprobar el vínculo.');
          } else {
            this.notificationService.success('Agregado con éxito.');
          }
        })
      ),
    { dispatch: false }
  );

  // change
  changeRequestIntegrante = createEffect(() =>
    this.actions$.pipe(
      ofType(entityIntegranteChangeRequest),
      switchMap((action) =>
        this.integranteService.changeIntegrante(action.item).pipe(
          // Se despachan ambas acciones: entityRolChangeSuccess actualiza el rol y muestra
          // el aviso de éxito, y entityIntegranteChangeSuccess limpia el isLoading del store
          // de integrantes (de lo contrario queda colgado y la vista no vuelve a renderizar).
          mergeMap((itemaux: Integrante) => [
            entityRolChangeSuccess({ item: itemaux.rol }),
            entityIntegranteChangeSuccess({
              item: { id: itemaux.rol.id, changes: itemaux }
            })
          ]),
          catchError((error) => of(entityIntegranteChangeFailure({ error })))
        )
      )
    )
  );

  integranteDeleteSuccess = createEffect(() =>
    this.actions$.pipe(
      ofType(entityIntegranteDeleteSuccess),
      tap(() => {
        this.notificationService.success('Eliminado con éxito.');
      })
    ),
    { dispatch: false }
  );

  changeSuccessIntegrante = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityRolChangeSuccess),
        tap(() => {
          this.notificationService.success('Actualizado con éxito.');
          // this.router.navigate(['']);
        })
      ),
    { dispatch: false }
  );

  changeFailureIntegrante = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityIntegranteChangeFailure),
        tap((action: any) => {
          const detalle = action?.error?.error?.errors?.[0]?.detail;
          this.notificationService.error(
            detalle ||
              'No se pudo completar el cambio de rol. Verifique que haya adjuntado el archivo de acreditación de representación e intente nuevamente.'
          );
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private integranteService: IntegranteService,
    private router: Router,
    private notificationService: NotificationService,
  ) {
    this.integranteService.url = environment.apiUrl;
  }
}
